import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[900px] flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
        <span className="font-heading text-[88px] font-extrabold leading-none text-primary-200 md:text-[120px]">
          404
        </span>
        <h1 className="mt-2 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
          这条视频走丢了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
          你访问的页面不存在或已被移动。回到首页看看今天的精选，或者按分类继续逛。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-5-line text-base"></i>
            返回首页
          </Link>
          <Link
            to="/search"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-search-line text-base"></i>
            搜索视频
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}